import { call, put, takeLatest } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { FetchDriver, SubmitTemporaryDriverLicense } from 'src/constants/actionTypes'
import { SubmitTemporaryDriverLicenseRequest } from 'src/interfaces/temporaryDriverLicense'
import { captureSentryError } from 'src/utils/sentry'
import { getApiErrorMessage } from 'src/utils/errorHandlers'
import { GcsFileReferenceDto, uploadFileToGcs } from './api/gcsUpload'

function* onSubmitTemporaryDriverLicense(action: AsyncAction<SubmitTemporaryDriverLicenseRequest>) {
  const { stepId, temporaryLicenseFile, selfieFile, previousLicenseFile } = action.payload

  try {
    const temporaryLicense = (yield call(
      uploadFileToGcs,
      {
        stepId,
        originalname: temporaryLicenseFile.name,
        mimeType: temporaryLicenseFile.type,
        size: temporaryLicenseFile.size,
      },
      temporaryLicenseFile,
    )) as GcsFileReferenceDto

    const selfie = (yield call(
      uploadFileToGcs,
      {
        stepId,
        originalname: selfieFile.name,
        mimeType: selfieFile.type,
        size: selfieFile.size,
      },
      selfieFile,
    )) as GcsFileReferenceDto

    let previousLicense: GcsFileReferenceDto | undefined

    if (previousLicenseFile) {
      previousLicense = (yield call(
        uploadFileToGcs,
        {
          stepId,
          originalname: previousLicenseFile.name,
          mimeType: previousLicenseFile.type,
          size: previousLicenseFile.size,
        },
        previousLicenseFile,
      )) as GcsFileReferenceDto
    }

    yield call(callClientSecureApi, Endpoints.SubmitTemporaryDriverLicense, {
      method: 'POST',
      apiService: ApiService.Paraworks,
      body: {
        stepId,
        temporaryLicense,
        selfie,
        ...(previousLicense && { previousLicense }),
      },
    })

    yield put(SubmitTemporaryDriverLicense.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.temporaryDriverLicense.onSubmitTemporaryDriverLicense] error',
    })

    const errorMessage = getApiErrorMessage(err, 'Failed to submit temporary driver license')

    yield put(SubmitTemporaryDriverLicense.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* temporaryDriverLicenseSaga() {
  yield takeLatest(SubmitTemporaryDriverLicense.type.REQUEST, onSubmitTemporaryDriverLicense)
}
